import React from "react";
import logo from "../assets/images/DENT_LOGO.png";
import "../commons/BackColor.css";

const BarraSupDent = () => (
  <React.Fragment>
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="text-center mx-auto">
        <span className="iconSup mx-auto">
          <img
            src={logo}
            alt="logo"
            width="15%"
            className="imgSizeLogo mx-auto"
          />
        </span>
      </div>
    </nav>
  </React.Fragment>
);
export default BarraSupDent;
